import actionTypes from "../actionTypes";
import initialState from "./initialState";

export default function (state = initialState.lunch, action) {
  switch (action.type) {
    case actionTypes.LOAD_LUNCH_MENU:
      return {
        items: action.lunchMenu,
        loading: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lunch.js